<script setup lang="ts">
import {useApiFetchAgentExistByName, useApiFetchProjectExistByName} from "~/composables/api";

const emit = defineEmits<{
  (e: 'openProjectResultModal'): void,
  (e: 'openProjectNotFoundModal'): void,
  (e: 'openCompanyResultModal'): void,
  (e: 'openCompanyNotFoundModal'): void,
}>()

const keyword = defineModel<string>({
  required: true,
})

enum TabEnum {
  PROJECT = 'project',
  COMPANY = 'company'
}

const tab = ref<TabEnum>(TabEnum.PROJECT);


const onSearch = async ({keyword, tab}: { keyword: string, tab: TabEnum }) => {

  if (!keyword) {
    return;
  }

  if (tab === TabEnum.PROJECT) {
    const {data: projectExists} = await useApiFetchProjectExistByName(keyword)
    if (projectExists.value) {
      emit('openProjectResultModal')
    } else {
      emit('openProjectNotFoundModal')
    }
  } else if (tab === TabEnum.COMPANY) {
    const {data: agentExists} = await useApiFetchAgentExistByName(keyword)
    if (agentExists.value) {
      emit('openCompanyResultModal')
    } else {
      emit('openCompanyNotFoundModal')
    }
  }
}

</script>

<template>
  <section class="block1">
    <glx-block>
      <div class="block1Container">
        <img src='/img/policy/img/block1_背景.png' alt='背景1' class="bgImg"/>
        <div class="card">
          <img src='/img/policy/img/block1_背景2.png' alt='背景2'/>
          <div class="container">
            <div class="block1Search">
              <div class="tabFloor">
                <button class="btnItem" :class="{active: tab === TabEnum.PROJECT}" @click="tab = TabEnum.PROJECT">
                  申报项目查询
                </button>
                <button class="btnItem" :class="{active:tab === TabEnum.COMPANY}" @click="tab = TabEnum.COMPANY">
                  授权单位查询
                </button>
              </div>
              <div class="searchFloor">
                <div class="inputWrapper">
                  <input class="input" v-model="keyword" autoFocus
                         @keydown.enter="onSearch({keyword:keyword,tab:tab})"/>
                  <div
                      class="iconSearchWrapper"
                      @click="onSearch({keyword: keyword,tab: tab})"
                  >
                    <img class="iconSearch" src='/img/policy/img/block1_icon_搜索.png' alt=""/>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </glx-block>
  </section>
</template>

<style scoped lang="scss">
section.block1 {
  height: 772px;

  .block1Container {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    //padding-top: 96px;

    > .bgImg {
      position: absolute;
      top: 0;
      //left: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
      object-fit: none;
      height: 100%;
      max-width: 100%;
      display: block;
    }

    > .card {
      width: 1516px;
      height: 754px;
      background: #5A5B75;
      box-shadow: 0px 6px 43px 0px rgba(173, 0, 0, 0.35);
      border-radius: 6px;

      position: absolute;
      top: 96px;
      left: 50%;
      transform: translateX(-50%);
      //margin-left: auto;
      //margin-right: auto;
      //left: 202px;
      //right: 202px;

      > .bgImg {
        object-fit: fill;
      }

      > .container {
        position: absolute;
        bottom: 153px;
        left: 0;
        right: 0;

        .block1Search {
          > .tabFloor {
            display: flex;
            justify-content: center;

            > .btnItem {
              width: 148px;
              height: 48px;
              border-radius: 6px;
              //text-align: center;

              font-family: PingFang SC;
              font-weight: 400;
              font-size: 18px;
              line-height: 48px;

              background-color: rgba(255, 255, 255, 1);
              color: rgba(255, 0, 0, 1);

              &.active {
                background-color: rgba(255, 0, 0, 1);
                color: rgba(255, 255, 255, 1);
              }


              &:not(:first-child) {
                margin-left: 7px;
              }


            }
          }

          > .searchFloor {
            margin-top: 9px;

            > .inputWrapper {
              width: 908px;
              height: 66px;
              background: rgba(255, 255, 255, 0.8);
              border-radius: 6px;
              margin-left: auto;
              margin-right: auto;

              display: flex;
              align-items: stretch;

              > .input {
                flex-grow: 1;
                box-sizing: border-box;
                padding-left: 20px;
                height: 100%;

                text-align: center;

                background-color: transparent;
                caret-color: rgba(255, 0, 0, 1);

                @mixin text() {
                  font-family: PingFang SC;
                  font-weight: 500;
                  font-size: 22px;
                  color: #232325;
                  line-height: 26px;
                }

                @include text;

                &::placeholder {
                  @include text;
                }
              }

              > .iconSearchWrapper {
                position: relative;
                padding-top: 18px;
                //width: 31px;
                flex-shrink: 0;

                padding-left: 20px;
                padding-right: 24px;

                &:hover {
                  cursor: pointer;
                }

                > img {
                  object-fit: none;
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>